import { METADATA } from './Base';

export const onGetRequest = (params = {}, cb) => ({ params, cb, type: METADATA.GET_REQUEST });
export const onGetFailure = (errors = {}) => ({ errors, type: METADATA.GET_FAILURE });
export const onGetSuccess = (payload = {}) => ({ payload, type: METADATA.GET_SUCCESS });

export const onGetHobbiesRequest = (params = {}, cb) => ({ params, cb, type: METADATA.GET_HOBBIES_REQUEST });
export const onGetHobbiesFailure = (errors = {}) => ({ errors, type: METADATA.GET_HOBBIES_FAILURE });
export const onGetHobbiesSuccess = (payload = {}) => ({ payload, type: METADATA.GET_HOBBIES_SUCCESS });